module.exports = __webpack_public_path__ + "img/l2.4ff809c7.png";